import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../services/notification.service';
import { ApiService } from '../../../services/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-otp-modal',
  templateUrl: './otp-modal.component.html',
  styleUrl: './otp-modal.component.scss',
})
export class OtpModalComponent implements OnInit {
  submitted = false;
  isLoading = false;
  otpCode: string = '';
  resendCooldown: number = 0;
  otpTimer: any;

  constructor(
    private http: ApiService,
    public router: Router,
    private notify: NotificationService,
    public activeModal: NgbActiveModal,
    private store: StorageService
  ) {}

  ngOnInit(): void {}

  resendOtp(): void {
    this.http.get('retailers/approveTermsAndCondition').subscribe({
      next: (res: any) => {
        if (res.code === 1) {
          this.otpCode = '';
          this.notify.showSuccess('OTP resent successfully!', '');
          this.startResendCooldown();
        } else {
          this.notify.showError(res.message || 'Failed to send OTP', '');
        }
      },
      error: (err) => {
        console.error('OTP Generation Error:', err);
        this.notify.showError('Error sending OTP. Please try again.', '');
      },
    });
  }

  startResendCooldown(): void {
    this.resendCooldown = 90; // 90 seconds timer
    this.otpTimer = setInterval(() => {
      if (this.resendCooldown > 0) {
        this.resendCooldown--;
      } else {
        clearInterval(this.otpTimer);
      }
    }, 1000);
  }

  cancel() {
    this.otpCode = '';
    clearInterval(this.otpTimer);
    this.resendCooldown = 0;
    this.activeModal.dismiss(false);
  }

  verifyOtp(): void {
    this.isLoading = true;

    this.http
      .post('retailers/otpVerifyForAgreeTermsAndCondition', {
        otp: this.otpCode,
      })
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;

          if (res.code === 1) {
            this.store.set({
              termsAccepted: res.data.termsAccepted ? 'true' : 'false',
              termsAgreeDate: res.data.termsAgreeDate,
              termsUpdatedDate: res.data.termsUpdatedDate,
            });
            this.notify.showSuccess('OTP verified successfully!', '');
            clearInterval(this.otpTimer);
            this.activeModal.close(true); // Pass success back to parent
          } else {
            this.otpCode = '';
            this.notify.showError(
              res.message || 'Invalid OTP. Please try again.',
              ''
            );
          }
        },
        error: (err) => {
          this.otpCode = '';
          this.isLoading = false;
          console.error('OTP verification failed:', err);
          this.notify.showError(
            'OTP verification failed. Please try again.',
            ''
          );
        },
      });
  }
}
